<bds-equipment></bds-equipment>
